import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";
import "./App.css";


import Navbar from "./components/Navbar";

import VLogin from "./pages/VLogin";
import VAlign from "./pages/VAlign";
import VFeedback from "./pages/VFeedback";

class App extends React.Component{
constructor(props){
		super (props);
		this.state = {
						
			//Login component: determines the task to be sent to Align
			taskUserId: "None",
			
			//Align Component: user final steps to be sent to Submission
			finalUserSteps: ["there are no steps"],
			
			//Align ccomponent: user last step index to be sent to Submission in order to reproduce user board
			lastStepIdx:0,
			
			//Align component: the link from Align page to the next page. 
			// in Practice and Test it leads to the next Practice or Test. 
			// and in the actuall app it leads to Submission page
			linkFromAlign:"/feedback",
			
			//Test component: keeping an object of all the final board states of the test tasks 
			//to calculate the matching score. 
			//though it's relevant only for Test component it will be computed anyway also for other tasks, through it's useless (will be under notRelevant field). 
			finalBoardStatesArray:{},
			
			//Test component: key for the finalBoardStatesArray object
			testMode:"notRelevant",
			
			//feedback: when it is on practice mode the Note is not displayed
			practiceMode: false,
			
			
			
		}
		this.keepFinalUserSteps = this.keepFinalUserSteps.bind(this);
		this.keepTaskUserId  = this.keepTaskUserId.bind(this);
		this.practiceTestFeatures  = this.practiceTestFeatures.bind(this);
}


//Login component: when the user click Submit the taskUserId is recieved 
//and reset all variables to prevent data stream between consecutive tasks 
keepTaskUserId (taskUserIdTemp) {
	this.setState( {taskUserId:taskUserIdTemp,
					finalUserSteps: ["there are no steps"],
					lastStepIdx:0,
					linkFromAlign:"/feedback",
					finalBoardStatesArray:{},
					practiceMode: false,
					testMode:"notRelevant",
					});	
}

//Align Component: When the user click DONE the final user steps are recieved from align.
//finalBoardStatesArray is used only for the test tasks
keepFinalUserSteps = (userSteps) => {	
	this.setState ({
		finalUserSteps:userSteps[0],
		lastStepIdx: userSteps[1],
	});
	this.setState ( (prevState)=> ({
	finalBoardStatesArray:{...prevState.finalBoardStatesArray, [prevState.testMode]: userSteps[0][userSteps[1]]["board_state"]}
	}) )
};

//Practice/Test component: update the practice/test task and the link from Align page
practiceTestFeatures(practiceTaskUserId){
	this.setState( {
		taskUserId:practiceTaskUserId[0],
		linkFromAlign:practiceTaskUserId[1],
		practiceMode: true,
		testMode: practiceTaskUserId[0]
	} );
	
}

	render(){
	return (
		<div className="App">
		<Router>
			<Container>
			{/* <Navbar /> */}
				<Content>
				<Switch>				
					
					
					<Route path="/login" 
						render = { (props) => <VLogin 
						onSubmitTaskUserId = {this.keepTaskUserId}
						taskUserId={this.state.taskUserId}
						/> }
						/>
					
					<Route path="/align" 
						 render = { (props) => <VAlign  
						 taskUserId = {this.state.taskUserId}
						 getFinalUserSteps = {this.keepFinalUserSteps}
						 linkFromAlign={this.state.linkFromAlign}
						 /> } 
					/>					
					
					
					<Route path="/feedback" 
						 render = { (props) => <VFeedback
						 taskUserId = {this.state.taskUserId}
						 userSteps = {this.state.finalUserSteps}
						 lastStepIdx = {this.state.lastStepIdx}
						 practiceMode={this.state.practiceMode}
						 
						 /> } 
						 />
					
					
					
				</Switch>  
				</Content>
			</Container>
		</Router>
		</div>
		);
		
		}
}

export default App



const Container = styled.div`
  width: 100vw;
  min-height: 110vw;
  background: #e0e0e0;
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  display: flex;
  align-self: center;
`;

  // background: #e0e0e0;